/*
 * product-price-box.js
 * Updates the sale/regular price box (snippets/product-information.liquid)
 * when the selected variant changes. Loaded only on product templates from
 * layout/theme.liquid. Event-driven: product.js dispatches a bubbling 'change'
 * event on input[name="id"] after every variant switch.
 */
(function () {
  var dataEl = document.getElementById('ProductJSON');
  if (!dataEl) return;
  var product;
  try {
    product = JSON.parse(dataEl.textContent || '{}');
  } catch (e) {
    return;
  }
  if (!product || !product.variants) return;

  var lastVariantId = null;

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',');
  }

  function updatePriceBox(variantId) {
    var variant = product.variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variant) return;

    var price = variant.price;
    var compareAt = variant.compare_at_price;
    var saleBox = document.querySelector('.sale-price-box');
    var regularBox = document.querySelector('.regular-price-box');
    if (!saleBox || !regularBox) return;

    saleBox.classList.add('hidden');
    regularBox.classList.add('hidden');

    if (compareAt && compareAt > price) {
      saleBox.classList.remove('hidden');
      var salePrice = saleBox.querySelector('.sale-price');
      var originalPrice = saleBox.querySelector('.original-price');
      var discountEl = saleBox.querySelector('.discount-text strong');
      if (salePrice) salePrice.textContent = formatMoney(price);
      if (originalPrice) originalPrice.textContent = formatMoney(compareAt);
      if (discountEl) discountEl.textContent = Math.round((1 - price / compareAt) * 100) + '%';
    } else {
      regularBox.classList.remove('hidden');
      var regularPrice = regularBox.querySelector('.regular-price');
      if (regularPrice) regularPrice.textContent = formatMoney(price);
    }
  }

  function getVariantInput() {
    return (
      document.querySelector('input.main-input-value[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('input[name="id"]')
    );
  }

  function sync() {
    var input = getVariantInput();
    if (!input) return;
    var currentId = input.value;
    if (currentId && currentId !== lastVariantId) {
      lastVariantId = currentId;
      updatePriceBox(currentId);
    }
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.name === 'id') sync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
